import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import * as yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";

import Div from "@jumbo/shared/Div";
import { getAssetPath } from "app/utils/appHelpers";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { setPassword } from "app/redux/slice/authSlice";
import JumboPasswordField from "@jumbo/components/JumboFormik/JumboPasswordField";

const validationSchema = yup.object({
  newPassword: yup.string("").required("New Password is required"),
  confirmPassword: yup
    .string("")
    .required("Password is required")
    .oneOf([yup.ref("newPassword")], "Your passwords do not match."),
});

const SetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const email = location && location?.search.split("?email=");
  const handleSubmit = (data) => {
    data.email = email[1];
    dispatch(setPassword(data))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          navigate("/login");
        } else {
          enqueueSnackbar(res.data?.responseMessage, { variant: "error" });
        }
      });
  };
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: () => handleSubmit(formik.values),
  });

  return (
    <Div sx={{ width: 720, maxWidth: "100%", margin: "auto", p: 4 }}>
      <Card
        sx={{
          display: "flex",
          minWidth: 0,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <CardContent
          sx={{
            flex: "0 1 300px",
            position: "relative",
            // background: `#0267a0 url(${getAssetPath(
            //   `${ASSET_IMAGES}/voolFashion/products.png`
            // )}) no-repeat center`,
            backgroundSize: "cover",
            "&::after": {
              display: "inline-block",
              position: "absolute",
              content: `''`,
              inset: 0,
              backgroundColor: alpha("#000000", 0.6),
            },
          }}
        >
          <Div
            sx={{
              display: "flex",
              minWidth: 0,
              flex: 1,
              flexDirection: "column",
              color: "common.white",
              position: "relative",
              zIndex: 1,
              height: "100%",
              minHeight: { md: 320 },
            }}
          >
            <Div sx={{ mb: 2 }}>
              <Typography
                variant={"h3"}
                color={"inherit"}
                fontWeight={500}
                mb={3}
              >
                Set Password
              </Typography>
              <Typography variant={"body1"} mb={1} sx={{ maxWidth: 270 }}>
                By entering your Password you set new password, Kindly follow
                instruction.
              </Typography>
            </Div>
            <Div sx={{ mt: "auto" }}>
              <Link href="#" underline="none" sx={{ display: "inline-flex" }}>
                <img
                  style={{ width: "100%", maxWidth: "120px" }}
                  src={`${ASSET_IMAGES}/vool-logo.png`}
                  alt="Vool Fashion"
                />
              </Link>
            </Div>
          </Div>
        </CardContent>
        <CardContent sx={{ flex: 1, p: 4 }}>
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Div
                sx={{
                  display: "flex",
                  minWidth: 0,
                  flex: 1,
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Div sx={{ mb: 2 }}>
                  <Grid mb={1}>
                    <Grid mb={3} mt={{ md: 3, sm: 1 }}>
                      <JumboPasswordField
                        fullWidth
                        name="newPassword"
                        label="New Password"
                        type="password"
                      />
                    </Grid>
                    <Grid mb={3}>
                      <JumboPasswordField
                        fullWidth
                        name="confirmPassword"
                        label="Confirm Password"
                        type="password"
                      />
                    </Grid>
                    <Button
                      fullWidth
                      variant="contained"
                      buttonLabel="Reset Password"
                      onClick={formik.handleSubmit}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Div>
              </Div>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
    </Div>
  );
};

export default SetPassword;
